import { get, keyBy } from 'lodash'
import { CLEANUP_STATE } from '../../actions/shared'
import { FETCH_CUSTOMER_PAYMENTS_SUCCEEDED, FETCH_CUSTOMER_PAYMENTS_FAILED } from '../../actions/suites/customerPayment'

const defaultState = { byId: {}, byCustomerId: {}, requestFailed: false }

const reducer = (state = defaultState, action) => {
  switch(action.type) {
    case CLEANUP_STATE: {
      return defaultState
    }

    case FETCH_CUSTOMER_PAYMENTS_SUCCEEDED: {
      const customerPayments = get(action.payload, 'data.customerPayments', [])
      const byId = keyBy(customerPayments, 'uuid')

      let byCustomerId = {}
      customerPayments.forEach((payment) => {
        const customerId = get(payment, 'customerId', 'unknown')

        if (!byCustomerId[customerId]) byCustomerId[customerId] = []
        byCustomerId[customerId].push(payment.uuid)
      })

      return {
        ...state,
        byId: byId,
        byCustomerId: byCustomerId,
        requestFailed: false,
      }
    }

    case FETCH_CUSTOMER_PAYMENTS_FAILED: {
      return {
        ...state,
        requestFailed: true,
      }
    }

    default:
      return state

  }
}

export default reducer
